// Content of the public /features page, shared by the page itself
// (src/components/FeaturesPage.jsx) and its search-engine version
// (api/features-og.js), so what Google reads is exactly what visitors see.
// Plain data only — no JSX — because the edge function imports it too.
// Plan badges must match PLANS in App.jsx (onlineBooking = 基本版+,
// whatsapp = 專業版+, WhatsApp AI 自動回覆 = Chatwoot / WATI，另外付費).

export const HERO = {
  kicker: "香港寵物美容店專用預約系統",
  title: "少啲覆 WhatsApp，多啲時間剪毛。",
  lead: "客人自己揀服務、揀時間、價錢自動計好，WhatsApp 自動確認。你專心做美容，預約自己會入嚟。",
};

export const FEATURES = [
  {
    title: "按體重、毛長、品種自動計價",
    more: "price-list",
    body: "香港美容店唔係一個價：5kg 貴婦同 25kg 金毛，短毛同雙層毛，價錢都唔同。PettoBook 一開始就係咁設計。",
    points: [
      "揀一個設定模板（簡單 / 標準 / 精細 / 貓專門），3 分鐘出齊服務同價錢",
      "體型 × 毛長 × 品種，每格都可以自己改",
      "客人揀好毛孩，系統即刻計好佢隻狗嘅價錢，唔使再問「幾錢呀？」",
      "舊客特價：個別毛孩可以設專屬價",
    ],
    badges: [["全部方案", true]],
    shots: ["o6-templates-crop.jpg", "c2-service.jpg"],
    phoneSecond: true,
  },
  {
    title: "WhatsApp 自動確認，唔使逐個覆",
    more: "whatsapp",
    video: ["ai-chat.mp4", "ai-chat-poster.jpg"],   // the side-by-side AI booking demo replaces the static screenshot
    body: "客人網上落單，系統用你間舖自己嘅 WhatsApp 號碼即刻發確認：客人名、毛孩、日期、時間、服務，一個字都唔使打。",
    points: [
      "用 Meta 批核嘅官方範本，唔會被當垃圾訊息",
      "所有 WhatsApp 對話集中喺「訊息」，美容師輪流睇都得",
      "想 AI 代你答價錢、時間、幫客人預約？可以加 WhatsApp AI 自動回覆，需要另外付費開通第三方 Chatwoot 或 WATI",
    ],
    badges: [["專業版起", false], ["AI 自動回覆：Chatwoot / WATI 另外付費", false]],
    shots: ["o11-wa-confirm-crop.jpg"],
  },
  {
    title: "24 小時自助預約，收咗舖都照接單",
    more: "online-booking",
    body: "客人自己揀服務、加購、美容師同時間。系統只會顯示你真係得閒嘅時段，唔會撞期，唔會超賣。",
    points: [
      "按每位美容師嘅更表同已有預約計空檔",
      "加購（剪甲、刷牙、SPA）自動加埋總數",
      "預約條款、訂金政策客人要剔同意先可以落單",
    ],
    badges: [["免費版每月 10 個 · 基本版起不限次數", false]],
    shots: ["c5-time.jpg", "c8-done.jpg"],
    phones: true,
  },
  {
    title: "一鍵生成價目表，一個 QR Code 分享",
    more: "price-list",
    body: "改咗價唔使再搵人整圖。價目表按你設定嘅價錢自動排版，8 款配色，下載 PNG / JPEG 或者直接列印。",
    points: [
      "價目表：狗狗、貓貓、SPA、加購，分頁自動整理",
      "預約 QR 海報：貼喺舖頭、放上 IG，客人一掃就入到你間舖嘅預約頁",
    ],
    badges: [["全部方案", true]],
    shots: ["o7-pricelist.jpg", "o4-qr-crop.jpg"],
  },
  {
    title: "美容店目錄，幫你帶新客人",
    more: "directory",
    body: "PettoBook 有公開嘅寵物美容店目錄，附近嘅主人可以按地區搵到你、睇你嘅相片同服務，再直接預約。",
    points: [
      "開店即自動上架，免費",
      "已經喺目錄嘅店舖，可以上載商業登記證認領",
    ],
    badges: [["全部方案", true]],
    shots: ["c1-shop.jpg", "c3-spa.jpg"],
    phones: true,
  },
  {
    title: "由到店到收款，一頁睇晒",
    more: "daily",
    body: "行事曆、顧客資料、毛孩備註、收款、儲值、積分、套票，全部喺同一個地方。唔使一邊開 Excel、一邊開 WhatsApp、一邊翻簿仔。",
    points: [
      "預約詳情：到店 → 美容中 → 完成 → 報告，一撳就轉",
      "即場到店（Walk-in）幾秒登記",
      "手機、平板、電腦都用得",
    ],
    badges: [["行事曆・顧客：全部方案", true], ["儲值・套票：專業版起", false]],
    shots: ["o3-detail.jpg"],
  },
];

export const BOOKING_STEPS = [
  ["c1-shop.jpg", "① 入你間舖", "掃 QR 或者撳 IG 連結，用 Google / Apple 一撳登入"],
  ["c2-service.jpg", "② 揀服務", "按毛孩體重同品種，價錢即刻計好"],
  ["c3-spa.jpg", "③ SPA 升級", "可選，每款有清楚介紹"],
  ["c4-addons.jpg", "④ 加購", "剪甲、刷牙等，已包嘅自動標示"],
  ["c5-time.jpg", "⑤ 揀時間", "只顯示真係有空嘅時段"],
  ["c6-confirm.jpg", "⑥ 確認", "可用套票、積分，寫低美容要求"],
  ["c7-terms.jpg", "⑦ 同意條款", "訂金、改期、遲到政策，一次講清楚"],
  ["c8-done.jpg", "⑧ 預約成功", "即刻出現喺你嘅行事曆"],
];

export const DAY = [
  ["o10-dayflow-crop.jpg", "朝早開舖", "一眼睇晒今日", "每位美容師一行，邊張單已付、邊張未付，今日營業額喺右上角。"],
  ["o9-walkin-crop.jpg", "有客行入嚟", "即場到店，幾秒登記", "搵返客人或者即場開新客，撳「登記 & 立即開始美容」。"],
  ["o3-detail.jpg", "做緊美容", "一撳轉狀態", "到店、美容中、完成；毛孩嘅過敏同注意事項一打開就見到。"],
  ["o8-customers-crop.jpg", "熟客再嚟", "客人資料自動記低", "每位客人嘅毛孩、儲值、積分同過往預約，搜尋名或電話一撳就搵到。"],
];

export const FAQ = [
  ["我唔識電腦，會唔會好難用？", "揀一個設定模板，價錢已經幫你填好，改幾個數字就用得。日常就係睇行事曆、撳一撳改狀態。唔明嘅地方可以睇使用教學，或者直接搵我哋。"],
  ["我啲客人習慣 WhatsApp，佢哋肯唔肯網上預約？", "PAWSIN 嘅客人都係 WhatsApp 用開嘅，而家 94% 預約係客人自己網上落單，仲有 99 張係晚上 9 點至朝早 9 點落嘅。你亦可以繼續用 WhatsApp，自動確認會用返你自己嘅號碼發出。"],
  ["我已經有幾百個客人，要唔要重新入過？", "唔使一次過入。客人第一次網上預約就會自動建立資料；即場到店都可以幾秒開新客。"],
  ["真係免費？", "開店、上目錄、行事曆同顧客管理都係免費，客人網上自助預約每月仲有 10 個免費名額，可以先試用。要不限次數，由基本版 HK$128/月起。新店舖仲有 14 日專業版免費試用，唔使信用卡。"],
  ["客人資料安全嗎？", "每間店嘅資料互相隔離，其他店睇唔到你嘅客人。所有連線都經加密。"],
  ["可以喺手機用嗎？", "可以。PettoBook 喺手機、平板、電腦都用得，瀏覽器打開即用，亦可以加到主畫面。"],
  ["收銀 POS 要另外俾錢嗎？", "唔使。基本版起已包含收銀：基本版 100 件商品；專業版 500 件，加庫存、退款換貨、交更同優惠；旗艦版商品無上限，加採購同 AI 新增商品。"],
];

export const PLANS = [
  ["免費版", "0", ["開店 + 上目錄", "預約排程（行事曆）", "每月 10 個網上預約（試用）", "顧客・毛孩管理", "價目表・QR 海報", "1 位美容師"]],
  ["基本版", "128", ["不限次數 24 小時網上預約", "自動通知", "營業分析", "收銀 POS（100 件商品）", "3 位美容師"]],
  ["專業版", "268", ["WhatsApp 預約確認", "儲值・套票・電子積分卡", "店主 AI 助手", "收銀加庫存・交更（500 件）", "5 位美容師"], true],
  ["旗艦版", "528", ["會員積分", "品牌專屬 App", "收銀全功能・商品無上限", "8 位美容師"]],
];

// ── Task pages: /features/<slug> ────────────────────────────────────────────
// One page per job a shop does, reachable from the tab bar on every features
// page. Each has its own search title so it can rank for that job
// (e.g. 寵物美容價目表, 網上預約系統). Claims must stay true to the plan
// flags in App.jsx PLANS; every screenshot is the demo shop, numbers redacted.
// steps: [image, title, text]   faq: [question, answer]
export const TASK_PAGES = [
  {
    slug: "daily",
    tab: "每日運作",
    kicker: "每日運作",
    title: "由開舖到收舖，一個 App 搞掂。",
    lead: "今日預約、即場到店、美容進度同熟客資料，全部喺同一個地方。唔使再喺簿仔、WhatsApp 同 Excel 之間跳嚟跳去。",
    badges: [["行事曆・顧客管理：全部方案", true]],
    video: ["daily.mp4", "daily-poster.jpg"],
    steps: [
      ["o10-dayflow-crop.jpg", "09:00 開舖：一眼睇晒今日", "每位美容師一行，邊張單已付、邊張未付，今日營業額喺右上角。"],
      ["o9-walkin-crop.jpg", "有客行入嚟：幾秒登記", "搵返熟客或者即場開新客，撳「登記 & 立即開始美容」。"],
      ["o3-detail.jpg", "美容中：一撳轉狀態", "到店 → 美容中 → 完成；毛孩嘅過敏同注意事項一打開就見到。"],
      ["o8-customers-crop.jpg", "熟客再嚟：資料自動記低", "毛孩、儲值、積分同過往預約，搜尋名或電話一撳就搵到。"],
    ],
    points: [
      "每位美容師嘅預約分開一行，唔會撞期",
      "即場到店、網上預約、電話預約都喺同一個行事曆",
      "預約詳情一頁睇晒：客人、毛孩、服務、價錢、收款",
      "手機、平板、電腦都用得",
    ],
    faq: [0, 5, 2],
    seo: {
      title: "寵物美容店日常管理系統｜預約行事曆・即場到店・美容進度 · PettoBook",
      description: "寵物美容店日常管理：每位美容師嘅預約行事曆、即場到店幾秒登記、一撳轉美容狀態、熟客資料自動記低。手機平板電腦都用得，免費開店。",
      keywords: "寵物美容店管理系統,美容店預約行事曆,寵物美容排期,寵物店日常管理,美容師排班,寵物美容軟件",
    },
  },
  {
    slug: "pos",
    tab: "收銀 POS",
    kicker: "收銀 POS",
    title: "美容同零售，一張單收晒。",
    lead: "預約收款、賣洗毛液同小食、找續、收據、庫存同報表，全部喺同一個 App。美容費自動由預約帶入，客人嘅錢包同積分一齊用得。",
    badges: [["基本版起包含", false], ["庫存・退款・交更：專業版起", false], ["採購・AI 新增商品：旗艦版", false]],
    video: ["pos.mp4", "pos-poster.jpg"],
    steps: [
      ["pos-cart.jpg", "美容 + 零售一張單", "今日待收款一撳加入，再撳商品或掃條碼；全店優惠自動計。"],
      ["pos-pay.jpg", "現金自動計找續", "現金、信用卡、轉數快、錢包，仲可以分幾種方式付。預約即刻轉做已付。"],
      ["pos-stock.jpg", "賣出即扣庫存", "每件貨嘅庫存、成本同低庫存提示；收貨、盤點、報損都喺度做。"],
      ["pos-report.jpg", "報表一眼睇晒", "美容同零售分開計，收款方式用嚟對錢櫃，熱賣商品同每日營業額。"],
    ],
    points: [
      "預約收款同零售同一個收銀台，唔使兩部機",
      "相機或藍牙掃描槍掃條碼",
      "開更、交更點錢、Z 報表（專業版起）",
      "直接喺預約收嘅錢都會計入報表",
    ],
    faq: [6, 5],
    seo: {
      title: "寵物美容店收銀系統 POS｜預約收款・零售・庫存・報表 · PettoBook",
      description: "寵物美容店收銀 POS：預約美容費同零售一張單收，現金找續、信用卡、錢包，庫存自動扣，美容同零售分開報表。基本版起包含，免費開店。",
      keywords: "寵物店收銀系統,寵物美容POS,寵物用品店POS,美容店收銀,寵物店庫存管理,寵物店報表",
    },
  },
  {
    slug: "online-booking",
    tab: "網上預約",
    kicker: "24 小時網上預約",
    title: "收咗舖，客人照自己預約。",
    lead: "客人自己揀服務、加購、美容師同時間。系統只顯示你真係得閒嘅時段，唔會撞期，唔會超賣；第二朝開舖，預約已經喺行事曆。",
    badges: [["免費版每月 10 個 · 基本版起不限次數", false]],
    shots: { phones: true, shots: ["c5-time.jpg", "c8-done.jpg"] },
    stepsTitle: "客人點樣預約？8 步，1 分鐘",
    stepsPhones: true,
    steps: "BOOKING_STEPS",
    points: [
      "按每位美容師嘅更表同已有預約計空檔",
      "加購（剪甲、刷牙、SPA）自動加埋總數",
      "預約條款、訂金政策客人要剔同意先可以落單",
      "客人可以用 Google / Apple 一撳登入",
    ],
    proof: true,
    faq: [1, 3],
    seo: {
      title: "寵物美容網上預約系統｜客人 24 小時自助預約 · PettoBook",
      description: "寵物美容店網上預約系統：客人 24 小時自己揀服務、加購、美容師同時間，只顯示真係有空嘅時段，唔會撞期。真實店舖 94% 預約由客人網上自己落單。",
      keywords: "寵物美容網上預約,寵物美容預約系統,網上預約系統,狗狗美容預約,24小時預約,美容店預約",
    },
  },
  {
    slug: "price-list",
    tab: "自動計價・價目表",
    kicker: "自動計價・價目表",
    title: "價錢自動計，價目表一撳生成。",
    lead: "5kg 貴婦同 25kg 金毛，短毛同雙層毛，價錢都唔同。設定一次，客人揀好毛孩就即刻見到佢隻狗嘅價錢；改咗價，價目表自動更新。",
    badges: [["全部方案", true]],
    shots: { phoneSecond: true, shots: ["o6-templates-crop.jpg", "c2-service.jpg"] },
    steps: [
      ["o6-templates-crop.jpg", "① 揀設定模板", "簡單 / 標準 / 精細 / 貓專門，3 分鐘出齊服務同價錢。"],
      ["c2-service.jpg", "② 客人揀毛孩", "按體重、毛長同品種，價錢即刻計好。"],
      ["o7-pricelist.jpg", "③ 生成價目表", "狗狗、貓貓、SPA、加購分頁整理，8 款配色，下載 PNG / JPEG 或者列印。"],
      ["o4-qr-crop.jpg", "④ 分享預約 QR", "貼喺舖頭、放上 IG，客人一掃就入到你間舖嘅預約頁。"],
    ],
    points: [
      "體型 × 毛長 × 品種，每格都可以自己改",
      "舊客特價：個別毛孩可以設專屬價",
      "客人唔使再問「幾錢呀？」",
      "改咗價唔使再搵人整圖",
    ],
    faq: [0, 3],
    seo: {
      title: "寵物美容價目表生成｜按體重、品種自動計價 · PettoBook",
      description: "寵物美容價目表一撳生成：按體重、毛長、品種自動計價，8 款配色，下載 PNG / JPEG 或列印；預約 QR 海報貼舖頭或 IG。所有方案都有，免費開店。",
      keywords: "寵物美容價目表,美容價目表設計,寵物美容收費,狗狗美容價錢,按體重計價,預約QR code",
    },
  },
  {
    slug: "whatsapp",
    tab: "WhatsApp 確認",
    kicker: "WhatsApp 自動確認",
    title: "少啲覆 WhatsApp，多啲時間剪毛。",
    lead: "客人網上落單，系統用你間舖自己嘅 WhatsApp 號碼即刻發確認：客人名、毛孩、日期、時間、服務，一個字都唔使打。",
    badges: [["專業版起", false], ["AI 自動回覆：Chatwoot / WATI 另外付費", false]],
    video: ["intro.mp4", "intro-poster.jpg"],
    steps: [
      ["c8-done.jpg", "① 客人網上落單", "客人喺你間舖嘅預約頁揀好服務同時間。"],
      ["o11-wa-confirm-crop.jpg", "② 系統即刻發確認", "用 Meta 批核嘅官方範本，由你自己嘅號碼發出，唔會被當垃圾訊息。"],
      ["o10-dayflow-crop.jpg", "③ 預約入行事曆", "你唔使覆，預約已經排好喺美容師嗰一行。"],
    ],
    aiDemo: {
      title: "加購 AI 自動回覆：客人 WhatsApp 預約，AI 即刻處理",
      sub: "示範對話：AI 會講明自己係 AI 助手，只問名同體重，按你嘅價目表報價、查真正有空嘅時間，然後開單等你一撳確認。需要另外付費開通第三方 Chatwoot 或 WATI。",
      video: ["ai-chat.mp4", "ai-chat-poster.jpg"],
    },
    points: [
      "所有 WhatsApp 對話集中喺「訊息」，美容師輪流睇都得",
      "想 AI 代你答價錢、時間、幫客人預約？可以加 WhatsApp AI 自動回覆，需要另外付費開通第三方 Chatwoot 或 WATI",
    ],
    faq: [1, ["要唔要另外開 WhatsApp Business？", "要。確認訊息用你間舖自己嘅號碼發出，需要喺 設定 → 通訊 連接 WhatsApp Business（Meta、WATI 或 Chatwoot），並用 Meta 批核嘅範本。WhatsApp 範本訊息嘅費用由 Meta 或你嘅供應商收取，唔包喺 PettoBook 月費。使用教學有逐步設定。"]],
    seo: {
      title: "寵物美容 WhatsApp 預約確認｜用自己號碼自動發確認 · PettoBook",
      description: "客人網上預約後，自動用你間舖自己嘅 WhatsApp 號碼發確認：客人名、毛孩、日期、時間、服務。Meta 批核範本，所有對話集中管理。專業版起。",
      keywords: "WhatsApp 預約確認,WhatsApp 自動回覆,寵物美容 WhatsApp,WhatsApp Business 預約,自動發確認訊息",
    },
  },
  {
    slug: "customers",
    tab: "客戶・儲值套票",
    kicker: "客戶・儲值・套票",
    title: "熟客資料、儲值、套票，一頁睇晒。",
    lead: "每位客人嘅毛孩、儲值、積分、套票同過往預約自動記低。客人預約時可以用套票同積分，收款可以用儲值，唔使再翻簿仔對數。",
    badges: [["顧客管理：全部方案", true], ["儲值・套票・電子積分卡：專業版起", false], ["會員積分：旗艦版", false]],
    shots: { phoneSecond: true, shots: ["o8-customers-crop.jpg", "c6-confirm.jpg"] },
    steps: [
      ["o8-customers-crop.jpg", "搜尋即搵到", "搜名、電話或毛孩名，一撳打開客人資料。"],
      ["o3-detail.jpg", "預約詳情見晒", "儲值餘額、積分、電子積分卡、套票次數，同埋毛孩嘅注意事項。"],
      ["c6-confirm.jpg", "客人預約時用", "客人落單時可以用套票同積分，仲可以寫低美容要求。"],
    ],
    points: [
      "客人第一次網上預約就自動建立資料",
      "毛孩嘅過敏同注意事項，每次預約都會見到",
      "舊客特價：個別毛孩可以設專屬價",
      "每間店嘅資料互相隔離，其他店睇唔到你嘅客人",
    ],
    faq: [2, 4],
    seo: {
      title: "寵物美容店客戶管理｜儲值、套票、電子積分卡 · PettoBook",
      description: "寵物美容店客戶管理：熟客同毛孩資料自動記低，儲值、套票、電子積分卡同會員積分一頁睇晒，搜名或電話即搵到。顧客管理所有方案都有。",
      keywords: "寵物美容客戶管理,寵物店CRM,美容店儲值,寵物美容套票,電子積分卡,會員積分系統",
    },
  },
  {
    slug: "directory",
    tab: "目錄帶客",
    kicker: "美容店目錄",
    title: "附近主人搵到你，直接預約。",
    lead: "PettoBook 有公開嘅寵物美容店目錄，附近嘅主人可以按地區搵到你、睇你嘅相片同服務，再直接預約。開店即自動上架，免費。",
    badges: [["全部方案", true]],
    shots: { phones: true, shots: ["c1-shop.jpg", "c3-spa.jpg"] },
    steps: [
      ["c1-shop.jpg", "主人按地區搵店", "香港 18 區都有獨立頁面，附近嘅主人一搵就見到你。"],
      ["c3-spa.jpg", "睇你嘅服務同相片", "服務、SPA、價錢同相片清清楚楚，唔使先 WhatsApp 問。"],
      ["c5-time.jpg", "直接預約", "有開網上預約嘅店，主人可以即刻揀時間落單。"],
    ],
    points: [
      "開店即自動上架，免費",
      "已經喺目錄嘅店舖，可以上載商業登記證認領",
      "每間店有自己嘅預約頁同 QR Code",
    ],
    faq: [3, ["我間舖已經喺目錄，點認領？", "喺你間舖嘅目錄頁撳「認領此店」，上載商業登記證。核實後，嗰頁就會連結到你嘅帳戶，由你管理。"]],
    seo: {
      title: "寵物美容店免費上架目錄｜附近主人搵到你 · PettoBook",
      description: "寵物美容店免費上架 PettoBook 目錄：香港 18 區主人按地區搵到你、睇服務同相片，再直接預約。已喺目錄嘅店可以上載商業登記證認領。",
      keywords: "寵物美容店目錄,寵物美容店上架,免費宣傳美容店,寵物店推廣,香港寵物美容店",
    },
  },
];

// Resolve a task page's FAQ entries: a number picks from FAQ, a pair is its own.
export const taskFaq = (t, faqList = FAQ) => (t.faq || []).map((f) => (typeof f === "number" ? faqList[f] : f)).filter(Boolean);
// Resolve its steps: "BOOKING_STEPS" reuses the customer booking flow.
export const taskSteps = (t, steps = BOOKING_STEPS) => (t.steps === "BOOKING_STEPS" ? steps : t.steps || []);

// ── Interface text + the overview's fixed blocks (per language) ──────────────
export const UI = {
  lang: "zh-HK",
  overviewTab: "總覽",
  overviewTitle: "寵物美容預約系統｜香港美容店免費開店 · PettoBook",
  signup: "免費開店",
  demo: "睇示範店 →",
  openDemo: "打開示範店",
  navPricing: "收費", navHelp: "使用教學", navDirectory: "美容店目錄",
  heroNote: "14 日專業版免費試用 · 唔使信用卡 · 3 分鐘設定好",
  playApp: "Android 店主 App", playGet: "Google Play 下載",
  realScreens: "以下全部係真實系統畫面（示範店）。",
  howItWorks: "點樣運作",
  keyPoints: "重點",
  realShop: "真實店舖",
  faqTitle: "店主最常問",
  taskFinalTitle: "3 分鐘開店，今日就用得。",
  taskFinalSub: "仲可以睇吓 PettoBook 點幫你處理其他工作：",
  seePricing: "睇收費 →",
  more: "詳細睇 →",
  baTitle: "你而家嘅一日 vs 用咗 PettoBook",
  baSub: "預約、報價、確認、記錄，本來要你親手做嘅嘢，交俾系統做。",
  whyTitle: "專為香港美容店而設",
  bookingTitle: "客人點樣預約？8 步，1 分鐘",
  bookingSub: "呢個就係你啲客人會見到嘅畫面。想親手試？",
  dayTitle: "美容店嘅一日",
  daySub: "由開舖到收工，PettoBook 喺每一步幫你慳時間。",
  dayVideo: ["daily.mp4", "daily-poster.jpg", "美容店嘅一日：由開舖到收舖，一個 App 搞掂"],
  heroVideo: ["intro.mp4", "intro-poster.jpg"],
  helpLine: "逐步教學同常見問題解決：", helpLink: "使用教學中心 →",
  pricingTitle: "收費簡單，開店免費",
  pricingSub: "按月付，唔使簽長約。",
  recommended: "推薦",
  perMonth: " /月",
  aiNote: "* WhatsApp AI 自動回覆唔包喺任何方案：需要另外付費開通第三方 Chatwoot 或 WATI 帳戶，再連接 PettoBook。",
  finalTitle: "今晚收舖之後，讓客人自己預約。",
  finalSub: "3 分鐘開店，揀個模板，價錢就設定好。",
  foot: [["/", "主頁"], ["/pricing", "收費方案"], ["/help", "使用教學"], ["/directory", "搵美容店"], ["/blog", "美容知識"]],
  switchTo: ["/en/features", "EN"],
};
export const BA = {
  before: ["😩 以前", ["一邊剪毛一邊覆 WhatsApp「聽日有冇位？」", "逐個問體重、品種先報到價", "簿仔記預約，撞期先發現", "收咗舖嘅訊息，第二朝先覆，客人已經去咗第二間", "價目表改一次價就要搵人重新整圖"]],
  after: ["😊 而家", ["客人自己睇空檔、自己落單", "揀好毛孩，價錢自動計好", "每位美容師嘅時間自動計，唔會撞期", "24 小時接單，WhatsApp 自動確認", "價目表一撳生成，QR 海報即刻分享"]],
};
export const CASE = {
  title: "PAWSIN 日式寵物美容：客人自己識落單",
  stats: [["463", "個預約（2026 年 5 月起）"], ["94%", "由客人自己網上落單"], ["99", "個喺晚上 9 點至朝早 9 點落單"], ["210", "位客人"]],
  text: "99 張單喺收咗舖之後先落。以前呢啲客人要等到第二朝先有人覆，而家佢哋自己揀好時間，第二朝開舖已經喺行事曆度。",
  seo: "2026 年 5 月起 463 個預約，94% 由客人自己網上落單，99 個喺晚上 9 點至朝早 9 點落單，累積 210 位客人。",
};
export const SEO = {
  title: "寵物美容預約系統｜香港美容店免費開店 · PettoBook",
  description: "香港寵物美容店專用預約系統：按體重、品種自動計價，客人 24 小時網上自助預約，WhatsApp 自動確認，一鍵生成價目表同 QR Code。真實店舖 94% 預約由客人自己網上落單。免費開店。",
  keywords: "寵物美容預約系統,寵物美容店管理系統,寵物美容軟件,美容店預約系統,狗狗美容預約,網上預約系統,WhatsApp 預約確認,寵物美容價目表,pet grooming software Hong Kong,grooming booking system",
  crumb: "寵物美容店預約系統", home: "主頁",
  whyHeading: "點解美容店揀 PettoBook", stepsHeading: "客人點樣網上預約（8 步）", plansHeading: "收費方案",
  caseHeading: "真實店舖：PAWSIN 日式寵物美容",
  videoName: "PettoBook 40 秒介紹：寵物美容店預約系統", dailyVideoName: "美容店嘅一日：由開舖到收舖，一個 App 搞掂 · PettoBook",
  dailyVideoDesc: "由開舖睇今日預約、客人 24 小時自助預約、即場到店登記、美容師排期、一撳轉狀態，到熟客資料自動記低。",
};

// Everything one language needs, in one object.
export const ZH = { HERO, FEATURES, BOOKING_STEPS, DAY, FAQ, PLANS, TASK_PAGES, UI, BA, CASE, SEO, base: "/features" };
